import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Button, Card, CardBody, CardHeader, Col, Collapse, Container, Input, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, Row, Spinner, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ApplicationState } from '../../store';
//import * as CreditCardStore from '../../store/CreditCard';
import * as ServiceContractRenewChgStore from '../../store/ServiceContractRenewCharge';
import { LoadingIcon } from '../Misc/Loading';
import { SaCurrency, SaDate, SaLabel } from '../Misc/SawinComponents';
import { useEffect, useState } from 'react';
import * as CreditCardMdls from '../../models/CreditCardModel';
import * as ChargeRenewMdls from '../../models/ServiceContractRenewChargeViewModel';
import * as ARInvoiceMdls from '../../models/ArInvoiceModel';
import * as SessionMdl from '../../models/SessionModel';
//const Cleave = require('../../../node_modules/cleave.js/react');
import { SaCreditCardNumber } from '../Misc/SawinCreditCardNumber';

type MyProps =
    { SessionState: SessionMdl.SessionModel, ScreenState: ChargeRenewMdls.ServiceContractRenewChargeScreenStatus } & typeof ServiceContractRenewChgStore.actionCreators;

const ServiceContractRenewCharge: React.FunctionComponent<MyProps> = (props: MyProps) => {


    const ServiceContractRenewInitialState = (props: MyProps): CreditCardMdls.CreditCardModel => {
        return {
            ...CreditCardMdls.initialState,
            avsStreet: props.SessionState.SelectedAR.address.line1,
            avsZip: props.SessionState.SelectedAR.address.zip
        }
    }    

            
    const PayNowBtn = () => {
        if (props.ScreenState.prossesingStatus != CreditCardMdls.CreditCardProcessStatus.InProcesses) {
            return (<input type="submit" value="Pay Now!" className="btn btn-success" id="AuthorizeBtn" name="AuthorizeBtn" />);
        } else {
            return (<span>Loading<Spinner size="sm" color="primary" /></span>);
        }
    }

    const PayInvoice = () => {

        const [CreditCardInfo, updateCreditCard] = useState<CreditCardMdls.CreditCardModel>(ServiceContractRenewInitialState(props));

        const SubmitEvent = (e: React.FormEvent) => {
            e.preventDefault();
            if (CreditCardInfo.number && CreditCardInfo.number.length >= 15 && CreditCardInfo.number.length <= 16) {
                props.renewAndChargeCreditCard(CreditCardInfo);
            } else {
                alert("Credit Card number is not valid");
            }            
        }

        const handleChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
            console.log("handleChange");
            e.preventDefault();
            if (e.target.id == 'customer.name') {
                var valueChangedCust = { customer: { ...CreditCardInfo.customer, name: e.target.value } };            
                updateCreditCard({ ...CreditCardInfo, ...valueChangedCust });
            } else if (e.target.id == 'customer.email') {
                var valueChangedCust = { customer: { ...CreditCardInfo.customer, email: e.target.value } };
                updateCreditCard({ ...CreditCardInfo, ...valueChangedCust });
            } else
            {
                var valueChanged = { [e.target.id]: e.target.value };
                updateCreditCard({ ...CreditCardInfo, ...valueChanged });
            }
        }

        const handleCleveChange = (e: any) => {
            e.preventDefault();
            var valueChanged = { [e.target.id]: e.target.rawValue };
            updateCreditCard({ ...CreditCardInfo, ...valueChanged });

        }

        const handleCreditCardTypeChange = (type: any) => {
 
            const amexImg = document.getElementById("amex-img");
            const visaImg = document.getElementById("visa-img");
            const mastercardImg = document.getElementById("mastercard-img");
            const discoverImg = document.getElementById("discover-img");
            switch (type) {
                case "amex":
                    if (amexImg) { amexImg.style.display = "block"; }
                    break;
                case "visa":
                    if (visaImg) visaImg.style.display = "block";
                    break;
                case "mastercard":
                    if (mastercardImg) mastercardImg.style.display = "block";
                    break;
                case "discover":
                    if (discoverImg) discoverImg.style.display = "block";
                    break;
                default:
                    if (amexImg) amexImg.style.display = "none";
                    if (discoverImg) discoverImg.style.display = "none";
                    if (mastercardImg) mastercardImg.style.display = "none";
                    if (visaImg) visaImg.style.display = "none";
            }

        }
      
        return (<Card>
            <CardHeader>
                <h3> Pay Renewal</h3>                
                <Row>
                    <Col className="right-align">
                        <SaLabel Text={'Payment Amount'} />
                        <SaCurrency Amount={props.ScreenState.amount} />
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={SubmitEvent}>

                    <SaLabel Text="Name" />
                    <input type="text" onChange={handleChange} required className="form-control" key="customer.name" id="customer.name" name="customer.name" value={CreditCardInfo.customer.name} />


                    <SaLabel Text="Address" />
                    <input type="text" onChange={handleChange} required className="form-control" key="avsStreet" id="avsStreet" name="avsStreet" value={CreditCardInfo.avsStreet} />

                    <SaLabel Text="Zip" />
                    <input type="text" onChange={handleChange} required className="form-control" key="avsZip" id="avsZip" name="avsZip" value={CreditCardInfo.avsZip} />


                    <SaLabel Text="Card Number" />
                    {/*<input type="text" onChange={handleChange} className="form-control" key="number" id="number" name="number" value={CreditCardInfo.number} />*/}
                    <Row><Col xs='12'>
                        <SaCreditCardNumber
                            required
                            placeholder="Enter credit card number"
                            options={{
                                creditCard: true,                                
                            }} className="form-control"
                            onChange={handleCleveChange}
                            key="number" id="number" name="number"
                        />
                    </Col>                        
                    </Row>


                    <SaLabel Text="CVV" />
                    <input type="text" onChange={handleChange} required className="form-control" key="cvv" id="cvv" name="cvv" value={CreditCardInfo.cvv} maxLength={4} />


                    <Row>
                        <Col xs={6}>
                            <SaLabel Text="Exp. Month" />
                            <select onChange={handleChange} className="form-control" key="expiryMonth" id="expiryMonth" name="expiryMonth" value={CreditCardInfo.expiryMonth}>
                                <option value=""></option>
                                <option value="1">January</option>
                                <option value="2">February</option>
                                <option value="3">March</option>
                                <option value="4">April</option>
                                <option value="5">May</option>
                                <option value="6">June</option>
                                <option value="7">July</option>
                                <option value="8">August</option>
                                <option value="9">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </select>
                        </Col>
                        <Col xs={6}>
                            <SaLabel Text="Year" />
                            <select onChange={handleChange} className="form-control" key="expiryYear" id="expiryYear" name="expiryYear" value={CreditCardInfo.expiryYear}>
                                <option></option>
                                <option>2021</option>
                                <option>2022</option>
                                <option>2023</option>
                                <option>2024</option>
                                <option>2025</option>
                                <option>2026</option>
                                <option>2027</option>
                                <option>2028</option>
                            </select>
                        </Col>
                    </Row>

                    <SaLabel Text="Email For Receipt" />
                    <input type="text" onChange={handleChange} className="form-control" key="customer.email" id="customer.email" name="customer.email" value={CreditCardInfo.customer.email} />


                    <div className="col-sm-12" style={{ textAlign: "right" }}>
                        <PayNowBtn />
                    </div>
                </form>
            </CardBody>
        </Card>);
    }

    const PayInvoiceResult = () => {
        if (props.ScreenState.success) {
            return (<Card>
                <CardBody>
                    <p className='center-align'>
                        <img src={'./img/checkmark.gif'} />
                    </p>
                    <p className='center-align'>
                        Your Payment is Complete
                    </p>
                    <p className='center-align'>
                        <a href="#">Get your receipt here</a>
                     </p>
                </CardBody>
            </Card>);
        } else {
            return (<Card>
                <CardBody>
                    <p className='center-align'>
                        <img src={'./img/cross.gif'} />
                    </p>
                    <p className='center-align'>
                        Your Payment was not processed.
                        </p>
                    <p className='center-align'>
                        {props.ScreenState.error}
                     </p>
                </CardBody>
            </Card>);
        }
    }
  
    return (
        <Container fluid={true}>
            <LoadingIcon loading={false} title={props.SessionState.SelectedSM.id + " - " + props.SessionState.SelectedSM.name.displayName} address={props.SessionState.SelectedSM.address} />
            {
                (props.ScreenState.prossesingStatus != CreditCardMdls.CreditCardProcessStatus.Finished ? <PayInvoice /> : <PayInvoiceResult />)
            }        

        </Container>
    );
}

export default connect((state: ApplicationState) =>
({
    ...{        
        SessionState: state.sessionState, ScreenState: state.serviceContractRenewChargeCardState        
    }
}),
    ServiceContractRenewChgStore.actionCreators)(ServiceContractRenewCharge as any);